import { render, staticRenderFns } from "./NewcomerPage.vue?vue&type=template&id=3dcfbe00&scoped=true&"
import script from "./NewcomerPage.vue?vue&type=script&lang=js&"
export * from "./NewcomerPage.vue?vue&type=script&lang=js&"
import style0 from "./NewcomerPage.vue?vue&type=style&index=0&id=3dcfbe00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcfbe00",
  null
  
)

export default component.exports